export const pointOnPlot = (
	root: HTMLElement,
	clientX: number,
	clientY: number,
	count: number,
	value: number | null,
) => {
	const grid = root.querySelector('.apexcharts-grid')
	if (!grid || count < 1) return null
	const gridBox = grid.getBoundingClientRect()
	const overPlot =
		clientX >= gridBox.left &&
		clientX <= gridBox.right &&
		clientY >= gridBox.top &&
		clientY <= gridBox.bottom
	if (!overPlot) return null
	const index =
		count === 1
			? 0
			: Math.min(
					count - 1,
					Math.max(
						0,
						Math.round(
							((clientX - gridBox.left) / gridBox.width) * (count - 1),
						),
					),
				)
	const labels = Array.from(root.querySelectorAll('.apexcharts-yaxis-label'))
		.map(node => {
			const box = node.getBoundingClientRect()
			const source = node.querySelector('tspan') || node
			const raw = String(source.textContent)
				.replace(/\s/g, '')
				.replace(',', '.')
			return {
				value: raw ? Number(raw) : Number.NaN,
				top: box.top + box.height / 2,
			}
		})
		.filter(item => Number.isFinite(item.value))
	let y = gridBox.top + gridBox.height / 2
	if (value != null && labels.length >= 2) {
		const low = labels.reduce((left, right) =>
			left.value < right.value ? left : right,
		)
		const high = labels.reduce((left, right) =>
			left.value > right.value ? left : right,
		)
		const span = high.value - low.value
		const ratio = span === 0 ? 0 : (value - low.value) / span
		y = low.top + (high.top - low.top) * ratio
	}
	const x =
		count === 1
			? gridBox.left + gridBox.width / 2
			: gridBox.left + (index / (count - 1)) * gridBox.width
	return { index, x, y }
}

export const placeTip = (
	root: HTMLElement,
	tip: HTMLElement,
	dot: HTMLElement | null,
	x: number,
	y: number,
) => {
	const rootBox = root.getBoundingClientRect()
	if (dot) {
		dot.style.display = 'block'
		dot.style.left = `${x - rootBox.left}px`
		dot.style.top = `${y - rootBox.top}px`
	}
	tip.style.display = 'block'
	let left = x - rootBox.left - tip.offsetWidth / 2
	const top = y - rootBox.top - tip.offsetHeight - 14
	if (left < 8) left = 8
	const maxLeft = rootBox.width - tip.offsetWidth - 8
	if (left > maxLeft) left = Math.max(8, maxLeft)
	tip.style.left = `${left}px`
	tip.style.top = `${top}px`
}
